import { FC, useState } from "react";
import { Button } from "@twilio-paste/button";
import { useVideoContext } from "../../../hooks/useVideoContext/useVideoContext";
import { useConferenceControlContext } from "../../../hooks/useConferenceControlContext/useConferenceControlContext";
import { useAppState } from "../../../hooks/useAppState/useAppState";
import { CloseIcon } from "@twilio-paste/icons/esm/CloseIcon"
import { ButtonProps } from "../../../types";
import { useUID } from "@twilio-paste/core/dist/uid-library";
import { Modal, ModalBody, ModalFooter, ModalFooterActions, ModalHeader, ModalHeading } from "@twilio-paste/core/modal";
import { Paragraph } from "@twilio-paste/core/paragraph";
import { Input } from "@twilio-paste/core/input";
import { HelpText, Label } from "@twilio-paste/core";
import { useChatContext } from "../../../hooks/useChatContext/useChatContext";
import { useSyncContext } from "../../../hooks/useSyncContext/useSyncContext";

export const EndEventButton: FC<ButtonProps> = (props: ButtonProps) => {
	const { room } = useVideoContext();
	const { disconnect: chatDisconnect } = useChatContext();
	const { disconnect: syncDisconnect } = useSyncContext();
	const { appState, appDispatch } = useAppState();
	const { endEvent } = useConferenceControlContext();
	const [error, setError] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState(false);
	const handleOpen = () => setIsOpen(true);
	const handleClose = () => setIsOpen(false);
	const [text, setText] = useState("");
	const modalHeadingID = useUID();

	const disconnect = async (): Promise<void> => {
			room!.emit("setPreventAutomaticJoinStreamAsViewer");
			room!.disconnect();
			chatDisconnect();
			syncDisconnect();
			endEvent();
			appDispatch({ type: "reset-state" });
	}

	const checkString = () => {
		if (text.toUpperCase() === "END PERMANENTLY") {
			setError(false);
			return disconnect();
		}
		return setError(true);
	}


	return (
		<><Button
			onClick={handleOpen}
			variant={props.menuButton ? "destructive_secondary" : "destructive"}
			disabled={appState.isRoomOpen}
			data-cy-disconnect>
			<CloseIcon decorative={true} /> End Conference
		</Button><Modal ariaLabelledby={modalHeadingID} isOpen={isOpen} onDismiss={handleClose} size="default">
			<ModalHeader>
				<ModalHeading as="h3" id={modalHeadingID}>
						End Conference
				</ModalHeading>
			</ModalHeader>
			<ModalBody>
				<Paragraph>You are about to end the conference.</Paragraph>
				<Label htmlFor="end_check" required>Please enter the word &quot;end permanently&quot; to confirm.</Label>
				<Input aria-describedby="end_check" id="end_check" name="end_check" type="text" onChange={(e) => setText(e.target.value)} placeholder="end permanently"  required/>
				{error && <HelpText id="end_check_help_text" variant="error">Invalid input. Please enter the word &quot;end permanently&quot;.</HelpText>}
			</ModalBody>
			<ModalFooter>
				<ModalFooterActions>
					<Button variant="secondary" onClick={handleClose}>
							Cancel
					</Button>
					<Button variant="destructive" onClick={checkString} >End Conference</Button>
				</ModalFooterActions>
			</ModalFooter>
		</Modal></>
	);
}
